const mapOrderTrackingPreviewOrder = order => {
  return { id: order.id, name: order.name, email: order.email, external_created: order.external_created }
}

export const transformResponseOrderTrackingPreviewOrders = response => {
  return response.results.map(mapOrderTrackingPreviewOrder)
}
